export function getBySearchCriteria (data, query) {
  return Object.values(data).filter(v => Object.keys(v).some(k => {
    if (v[k]) {
      return v[k].toString().toLowerCase().includes(query.hasOwnProperty('search')
        ? query.search.toLowerCase()
        : query.toLowerCase())
    }
    return false
  }))
}



// WEBPACK FOOTER //
// ./src/utils/helpers/GetterHelpers/CommonGetterFunctions.js